:host .main-content{height:100%;padding:0}:host .main-content .main-content-wrap{height:100%;padding:0;width:100%}
/*# sourceMappingURL=extra.component-3HCM66GL.css.map */
